import styled from 'styled-components';
import { theme } from '@/styles/theme';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
  width: 100%;
`;

export const Label = styled.label`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.neutral.darkGray};
`;

export const Input = styled.input`
  width: 100%;
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  font-size: ${theme.fontSizes.base};
  font-family: ${theme.fonts.body};
  color: ${theme.colors.neutral.darkGray};
  background: ${theme.colors.neutral.white};
  border: 2px solid ${theme.colors.secondary.ivory};
  border-radius: ${theme.borderRadius.lg};
  transition: all ${theme.transitions.fast};

  &::placeholder {
    color: ${theme.colors.neutral.gray};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary.royalBlue};
    box-shadow: 0 0 0 3px rgba(15, 52, 96, 0.1);
  }

  &:disabled {
    background: ${theme.colors.neutral.lightGray};
    cursor: not-allowed;
  }

  &[aria-invalid='true'] {
    border-color: ${theme.colors.error};
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  font-size: ${theme.fontSizes.base};
  font-family: ${theme.fonts.body};
  color: ${theme.colors.neutral.darkGray};
  background: ${theme.colors.neutral.white};
  border: 2px solid ${theme.colors.secondary.ivory};
  border-radius: ${theme.borderRadius.lg};
  transition: all ${theme.transitions.fast};
  min-height: 120px;
  resize: vertical;

  &::placeholder {
    color: ${theme.colors.neutral.gray};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary.royalBlue};
    box-shadow: 0 0 0 3px rgba(15, 52, 96, 0.1);
  }

  &:disabled {
    background: ${theme.colors.neutral.lightGray};
    cursor: not-allowed;
  }

  &[aria-invalid='true'] {
    border-color: ${theme.colors.error};
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  font-size: ${theme.fontSizes.base};
  font-family: ${theme.fonts.body};
  color: ${theme.colors.neutral.darkGray};
  background: ${theme.colors.neutral.white};
  border: 2px solid ${theme.colors.secondary.ivory};
  border-radius: ${theme.borderRadius.lg};
  transition: all ${theme.transitions.fast};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary.royalBlue};
    box-shadow: 0 0 0 3px rgba(15, 52, 96, 0.1);
  }

  &:disabled {
    background: ${theme.colors.neutral.lightGray};
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.error};
  margin-top: ${theme.spacing[1]};
`;

export const HelperText = styled.span`
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.neutral.gray};
  margin-top: ${theme.spacing[1]};
`;
